(function () {
    var app = new Vue({
        el: '#projects-vue',
        data: function () {
            return {
                projects: [],
                activeFilter: null,
                // Filter Categories determining which filter buttons to show:
                filterCategories: [
                    { buttonText: 'ALLE PROJEKTE', category: null },
                    { buttonText: 'Digitalisierung', category: 'Digitalisierung' },
                    { buttonText: 'Frontend', category: 'Frontend' },
                    { buttonText: 'User Experience', category: 'User Experience' },
                    { buttonText: 'Angular', category: 'Angular' },
                    { buttonText: 'AngularJS', category: 'AngularJS' },
                    { buttonText: 'React', category: 'React'},
                    { buttonText: 'Migration', category: 'Migration'},
                    { buttonText: 'Java', category: 'Java' },
                    { buttonText: 'NodeJS', category: 'NodeJS' },
                    { buttonText: 'TypeScript', category: 'TypeScript' },
                    { buttonText: 'Mobile', category: 'Mobile' },
                    { buttonText: 'Cloud', category: 'Cloud' },
                    { buttonText: 'Ionic', category: 'Ionic' },
                ],
            }
        },
        methods: {
            // Function proofs string everytime the /project-page is loaded and
            getRequiredFilter: function() {
              var categories = this.filterCategories;
              var currentUrl = window.location.hash;
              var urlLength = currentUrl.length;
              var indexOfQuerryBegin = currentUrl.indexOf('#');

              // remove '#' from string and cut out filter-category
              var filter = currentUrl.slice(indexOfQuerryBegin+1, urlLength);

              // compare string from url with given categories to filter
              for (var i=0; i < categories.length; i++) {
                if(this.ciEquals(categories[i].category, filter)) {
                    // if strings are equal filter the matching category
                    this.loadProjects(categories[i].category);
                }
              }
            },

            // Compares two strings (case insensitive), returns true/false
            ciEquals: function(a, b) {
                return typeof a === 'string' && typeof b === 'string'
                ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
                : a === b;
            },

            // Loads the projects (case studies), filtered them by category if defined.
            loadProjects: function (category) {
                var that = this;
                that.activeFilter = (!category) ? null : category;
                Vue.http.get('/projekte/getprojects').then(function (res) {
                    that.projects = (!category) ? res.body.reverse() : that.filterProjects(res.body, category);
                }, function (e) { console.log(e) });
            },
            // Filters the projects by if they have a certain category.
            // This is done in an old way and is the same as the following in ES6:
            // .filter(p => p.categories.includes(category))
            filterProjects: function (projects, category) {
                var filteredProjects = [];
                for (var i=0; i<projects.length; i++) {
                    var p = projects[i];
                    for (var j=0; j<p.categories.length; j++) {
                        var c = p.categories[j];
                        if (c === category) {
                            filteredProjects.push(p);
                        }
                    }
                }
                return filteredProjects.reverse();
            }
        },
        created: function () {
            this.loadProjects();
            this.getRequiredFilter();
        },
        template:   '<div>' +
                        '<div class="space"></div>' +
                        '<div class="row" >' +
                            '<div class="col-md-12">' +
                                '<button style="margin-top: 15px" ' +
                                    'v-for="c in filterCategories"' +
                                    'class="btn btn-secondary" ' +
                                    'v-bind:class="{ myActive: activeFilter === c.category }" ' +
                                    'v-on:click="loadProjects(c.category)">' +
                                        '{{ c.buttonText }}' +
                                '</button>' +
                            '</div>' +
                        '</div>' +


                        '<div class="space"></div>' +
                        '<div class="row">' +
                            '<div v-for="p in projects" class="col-md-12 col-lg-6">' +
                                '<a class="customer-link neongreen" :href="\'/projekte/\' + p.slug">' + // link to detail page
                                    '<div class="customer-box">' +
                                        '<h4>{{ p.customer }}</h4>' +
                                        '<p>{{ p.title }}</p>' +
                                    '</div>' +
                                '</a>' +
                            '</div>' +
                            '<div class="col-md-12 col-lg-6"' +
                                'v-if="activeFilter == \'React\'" ' +
                                '>' +
                                '<div class="customer-link">' +
                                    '<div class="customer-box">' +
                                        '<h4>Weitere Projekte</h4>' +
                                        '<p>An weiteren Cases für <span class="bold">React</span> arbeiten wir aktuell</>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
    });
})();
